import { Alert, Box, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import type { UnusedMediaReportSummary } from '@api/types/storageReport'

/**
 * Where the report looked for references, and what it could not look at. A file is only as
 * "unused" as this list is complete, so the list is shown rather than taken on trust.
 */
export function ReferenceSourcesPanel({ summary }: { summary: UnusedMediaReportSummary }) {
  const sources = [...summary.referenceSources].sort((a, b) => b.referencedFiles - a.referencedFiles || a.name.localeCompare(b.name))

  return (
    <Box>
      {summary.notChecked.length > 0 && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
            Not checked — a file listed as unused may still be used here:
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            {summary.notChecked.map((item) => (
              <li key={item}>
                <Typography variant="body2">{item}</Typography>
              </li>
            ))}
          </Box>
        </Alert>
      )}

      <Paper variant="outlined">
        {/* A plain table: this is a short reference list, not a pageable data set. */}
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Source</TableCell>
                <TableCell>Kind</TableCell>
                <TableCell align="right">Files it uses</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sources.map((source) => (
                <TableRow key={`${source.kind}:${source.name}`}>
                  <TableCell sx={{ fontFamily: 'monospace', overflowWrap: 'anywhere' }}>{source.name}</TableCell>
                  <TableCell>
                    <Chip size="small" variant="outlined" label={source.kind} />
                  </TableCell>
                  <TableCell align="right">{source.referencedFiles.toLocaleString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  )
}
